import RouterErrorBoundary from "@/errors/RouterErrorBoundary/RouterErrorBoundary";
import AuthLayout from "@/layouts/Auth";
import React, { lazy, Suspense } from "react";
import PublicRoute from "@/guards/PublicRoute";

const Login = lazy(() => import("@/features/auth/pages/Login"));
const Register = lazy(() => import("@/features/auth/pages/Register"));
const ForgetPassword = lazy(() =>
  import("@/features/auth/pages/ForgetPassword")
);
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";

export const authRoutes = [
  {
    path: "/auth",
    errorElement: <RouterErrorBoundary />,
    element: (
      <PublicRoute>
        <Suspense fallback={<LoadingFeedback />}>
          <AuthLayout />
        </Suspense>
      </PublicRoute>
    ),
    children: [
      {
        path: "login",
        element: <Login />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "register",
        element: <Register />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "forget-password",
        element: <ForgetPassword />,
        errorElement: <RouterErrorBoundary />,
      },
    ],
  },
];
